import React from 'react';
import { Row, Col, Card, Button } from 'antd';
import GPayPaymentTitle from './GPayPaymentTitle';
import PaytmPaymentTitle from './PaytmPaymentTitle';

const SelectButton = (props: { title: string }) => {
  return <Button className="btn-green">{props.title}</Button>;
};

const PaymentDescription = () => {
  return (
    <Row style={{ padding: 15 }} gutter={[16, 16]}>
      <Col xs={24} sm={11} md={11} lg={11} xl={11} xxl={11}>
        <Card>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-evenly'
            }}
          >
            <GPayPaymentTitle />
            <SelectButton title="Select" />
          </div>
        </Card>
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 11, offset: 1 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 1 }}
        xxl={{ span: 11, offset: 1 }}
      >
        <Card>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-evenly'
            }}
          >
            <PaytmPaymentTitle />
            <SelectButton title="Select" />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default PaymentDescription;
